import { getPrimaryIdentityBadge } from "./identity";
import type { AccountSummary } from "../types/account";
import type { IdentityBadge, VerificationStatus } from "../types/identity";

export function accountTypeLabel(accountType: AccountSummary["accountType"]) {
  if (accountType === "teacher") return "Professeur";
  if (accountType === "institution") return "École";
  return "Étudiant";
}

export function accountDisplayName(account: Pick<AccountSummary, "accountType" | "displayName" | "institutionName" | "username">) {
  if (account.accountType === "institution") {
    return account.institutionName || account.displayName || "École Neqraw";
  }
  return account.displayName || (account.username ? `@${account.username}` : "Compte personnel");
}

export function accountHandle(account: Pick<AccountSummary, "username">) {
  return String(account.username ?? "").trim().replace(/^@/, "");
}

export function accountPrimaryBadge(account: AccountSummary): IdentityBadge | null {
  return account.badges?.[0] ?? getPrimaryIdentityBadge(account);
}

/** Short labels for compact identity rows. Backend enum values remain unchanged. */
export function accountPrimaryLabel(account: AccountSummary) {
  const badge = accountPrimaryBadge(account);
  if (badge?.kind === "institution") return account.verificationStatus === "verified" ? "École vérifiée" : "École";
  if (badge?.kind === "institution_premium") return "École premium";
  if (badge?.kind === "teacher_verified") return "Prof vérifié";
  if (badge?.kind === "teacher_premium") return "Prof premium";
  if (badge?.kind === "teacher") return "Prof";
  if (badge?.kind === "student") return "Étudiant";
  return accountTypeLabel(account.accountType);
}

export function verificationStatusLabel(status: VerificationStatus) {
  if (status === "pending") return "En cours";
  if (status === "verified") return "Approuvé";
  if (status === "rejected") return "Refusé";
  return "Non vérifié";
}
